module.exports = __webpack_public_path__ + "static/united-kingdom-flag-xs-a8f2e337f310eac4cea14247c932f090.jpg";